import React, { Component } from "react";
import firebase from "../firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faMicrophoneSlash,
  faPlay,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";



class RecordingPage extends Component {
  state = {
    sentenceId: 0,
    showDoneModal: false,
    seconds: 0,
    languageDurationRecorded: 0,
    totalDurationRecorded: 0,
    recording: false,
    transcript: '',
    trError: false,
  };
  snapshot = null;
  totalSentences = null;
  language = this.props.appState.language;
  userDoc = null;
  
  async componentDidMount() {
    window.scrollTo(-100, -100)
    let recordAudio = () =>
      new Promise(async (resolve) => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            autoGainControl: false, //(2) [true, false]
            channelCount: 1, // {max: 2, min: 1}
            deviceId: "default",
            // groupId: null,
            echoCancellation: false, //(2) [true, false]
            latency: 0.01, //{max: 0.01, min: 0.01}
            noiseSuppression: false, //(2) [true, false]
            sampleRate: 48000, //{max: 48000, min: 48000}
            sampleSize: 16, //{max: 16, min: 16}
          },
          video: false,
        });
        const options = { mimeType: "audio/webm" };
        const mediaRecorder = new MediaRecorder(stream, options);
        let audioChunks = [];

        mediaRecorder.addEventListener("dataavailable", (event) => {
          audioChunks.push(event.data);
        });

        const start = () => {
          audioChunks = [];
          mediaRecorder.start();
        };

        const stop = () =>
          new Promise((resolve) => {
            mediaRecorder.addEventListener("stop", () => {
              const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
              const audioUrl = URL.createObjectURL(audioBlob);
              const audio = new Audio(audioUrl);
              const play = () => audio.play();
              resolve({ audioChunks, audioBlob, audioUrl, play });
            });

            mediaRecorder.stop();
          });

        resolve({ start, stop });
      });

    const recordButton = document.getElementById("start");
    const stopButton = document.getElementById("stop");
    const playButton = document.getElementById("play");
    const saveButton = document.getElementById("save");

    let recorder;
    let audio;
    let interval;

    recordButton.addEventListener("click", async () => {
      console.log("Recording");
      recordButton.setAttribute("disabled", true);

      if (!recorder) {
        recorder = await recordAudio();
      }
      recorder.start();
      this.setState({ seconds: 0, recording: true });
      interval = setInterval(
        () => this.setState({ seconds: this.state.seconds + 1 }),
        1000
      );
      stopButton.removeAttribute("disabled");
      playButton.setAttribute("disabled", true);
      saveButton.setAttribute("disabled", true);
    });

    stopButton.addEventListener("click", async () => {
      recordButton.removeAttribute("disabled");
      stopButton.setAttribute("disabled", true);
      playButton.removeAttribute("disabled");
      saveButton.removeAttribute("disabled");
      audio = await recorder.stop();
      this.setState({ recording: false });
      clearInterval(interval);
    });

    playButton.addEventListener("click", () => {
      audio.play();
    });

    saveButton.addEventListener("click", () => {
      
      // Create a root reference
      var storageRef = firebase.storage().ref();

      if(Number(this.state.sentenceId.toString().slice(-2)) > 14) {

	      console.log("Saving text");

	      if(this.state.transcript === '') {
	      	this.setState({trError: true});
	      	return;
	      }
	      
	      // Create a reference to 'mountains.jpg'
	      const location_txt = this.getLocation(
	        [
	          this.props.appState.providerId,
	          this.props.appState.subjectId,
	          this.props.appState.language,
	          "text",
	        ],
	        [
	          this.props.appState.providerId,
	          this.props.appState.subjectId,
	          this.props.appState.language,
	          this.state.sentenceId,
	          Date.now(),
	        ],
	        "text",
	      );
	      var storageLocationTxt = storageRef.child(location_txt);

	      storageLocationTxt.putString(this.state.transcript).then(() => {
	        console.log("Uploaded transcript successfully");
	        this.setState({trError: false});
          this.setState({transcript: ''});
          this.refs.transcript.value = '';
	      });
      }

      console.log("Saving audio");
      if (!audio || audio.audioChunks.length === 0) {
        alert("You need to record audio before saving");
        return;
      }

      // Create a reference to 'mountains.jpg'
      const location_wav = this.getLocation(
        [
          this.props.appState.providerId,
          this.props.appState.subjectId,
          this.props.appState.language,
          "wav",
        ],
        [
          this.props.appState.providerId,
          this.props.appState.subjectId,
          this.props.appState.language,
          this.state.sentenceId,
          Date.now(),
        ],
        "wav",
      );
      var storageLocationWav = storageRef.child(location_wav);

      storageLocationWav.put(audio.audioBlob).then(() => {
        console.log("Uploaded recording successfully");
        audio = null;
        recordButton.removeAttribute("disabled");
        stopButton.setAttribute("disabled", true);
        playButton.setAttribute("disabled", true);
        saveButton.setAttribute("disabled", true);
      });

      this.setState(
        {
          sentenceId:
            (this.state.sentenceId + 1) %
            (this.totalSentences == null
              ? this.snapshot.docs.length
              : this.totalSentences),
        },
        () => {
          this.getRandomSentenceFromFirestore(
            this.props.appState.language,
            this.state.sentenceId
          );
          this.incementSentenceCounter();
          // Uncomment this to track display sentences in an order
        }
      );
    });
    console.log(this.props.appState.langDocFirestore);
    this.userDoc = await firebase
      .firestore()
      .collection("users")
      .doc(this.props.appState.providerId)
      .collection("subjects")
      .doc(this.props.appState.subjectId)
      .get();
    this.setState(
      {
        sentenceId: this.props.appState.langDocFirestore.data().currentSentence,
        languageDurationRecorded: !this.props.appState.langDocFirestore.data()
          .durationRecorded
          ? 0
          : this.props.appState.langDocFirestore.data().durationRecorded,
        totalDurationRecorded: !this.userDoc.data().durationRecorded
          ? 0
          : this.userDoc.data().durationRecorded,
      },
      () =>
        this.getRandomSentenceFromFirestore(
          this.props.appState.language,
          this.state.sentenceId
        )
    );
  }

  getLocation = (folder_components, file_components, datatype) => {
    let folderLoc = "/";
    let fileName = "";

    folder_components.forEach((component) => {
      folderLoc = folderLoc + component + "/";
    });

    file_components.forEach((component) => {
      fileName = fileName + "_" + component;
    });

    if (datatype === "wav") {
    	let location = folderLoc + fileName + ".wav";
    	return location;
    }
    else {
    	let location = folderLoc + fileName + ".txt";
    	return location;
    }    
    
  };

  incementSentenceCounter = () => {
    console.log(
      this.props.appState.providerId,
      this.props.appState.subjectId,
      this.props.appState.language,
      this.state.languageDurationRecorded,
      this.state.totalDurationRecorded
    );
    this.setState(
      {
        languageDurationRecorded:
          this.state.languageDurationRecorded + this.state.seconds,
        totalDurationRecorded:
          this.state.totalDurationRecorded + this.state.seconds,
      },
      () => {
        firebase
          .firestore()
          .collection("users")
          .doc(this.props.appState.providerId)
          .collection("subjects")
          .doc(this.props.appState.subjectId)
          .collection("languages")
          .doc(this.props.appState.language)
          .update({
            currentSentence: this.state.sentenceId,
            durationRecorded: this.state.languageDurationRecorded,
          });
        firebase
          .firestore()
          .collection("users")
          .doc(this.props.appState.providerId)
          .collection("subjects")
          .doc(this.props.appState.subjectId)
          .update({
            durationRecorded: this.state.totalDurationRecorded,
          });
      }
    );
  };

  copyText = () => {
    var copyText = document.getElementById("subjectId");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    alert("Copied the text: " + copyText.value);
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  
  render() {
    return (
      <div
        style={{
          display:
            this.props.appState.currentPage === "record" ? "block" : "none",
        }}
      >
        <Modal
          show={this.state.showDoneModal}
          onHide={(e) => this.setState({ showDoneModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Are you sure you want to stop giving more recordings for today?
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => this.props.setCurrentPage("thank")}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              onClick={(e) => this.setState({ showDoneModal: false })}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
        <div
          style={{
            display:
              this.props.appState.providerId === "Anonymous" ? "block" : "none",
          }}
        >
          <div className="text-left ml-5" style={{ maxWidth: "300px" }}>
            <input
              type="text"
              value={this.props.appState.subjectId}
              id="subjectId"
              readOnly={true}
            ></input>

            <button onClick={this.copyText}>Copy your ID</button>
            <p>
              <small>
                Click on "Copy your ID" to copy your ID. Use this when you
                revisit us for future recordings.
              </small>
            </p>
          </div>
        </div>

        <div className="flex-container">
            <h4 className="text-center mt-4" id="prompt">
              {this.getPromptForLanguage(this.props.appState.language,this.state.sentenceId)}
            </h4>
        </div>
          
        <div className="flex-container mt-2" style={{ height: "400px" }}>
          <img
            id="sentence"
            src="https://via.placeholder.com/400x300"
            alt="Display"
            height="400px"
            width="600px"
          ></img>
        </div>

        <div className="flex-container">
          <button id="start" className="btn btn-circle btn-xl mr-4 mb-4">
            <FontAwesomeIcon icon={faMicrophone} size="4x" />
            Start recording
          </button>
          <button
            id="stop"
            className="btn btn-circle btn-xl mr-4 mb-4"
            disabled={true}
          >
            <FontAwesomeIcon icon={faMicrophoneSlash} size="4x" />
            Stop recording
          </button>
          <button id="play" className="btn btn-circle btn-xl mr-4 mb-4" disabled={true}>
            <FontAwesomeIcon icon={faPlay} size="4x" />
            Play
          </button>
        </div>

        {this.state.recording ? (
          <div className="text-center mt-5">
            <p>Recording...</p>
            <p>{this.state.seconds}s</p>
          </div>
        ) : null}

        <div
          style={{
            justifyContent: "center",
            display: Number(this.state.sentenceId.toString().slice(-2)) < 15
              ? "none"
              : "flex",
          }}
        >
	        <div className="input-field form-group required mt-4 mb-4">
              <label htmlFor="transcript" className="control-label">
                {this.props.appState.language === "english" ? (
                  <>
                    Please enter the <b> exact </b> sentence(s) you spoke 
                  </>
                ) : (
                  <>
                    Please enter the <b> exact </b> sentence(s) you spoke using English alphabets 
                  </>
                )}                  
              </label>
              <textarea
	              ref='transcript'
	              onChange={(e) => this.setState({transcript: e.target.value})}
	              className="form-control"
	            />
	            {this.state.trError ? (
	              <div style={{ fontsize: 10, color: "red" }}>
	                Please specify
	              </div>
	            ) : null}
              {this.props.appState.language !== "english" ? (
                <div>
                  <b> Example: </b> 
                  <br></br>
                  If you spoke <span>      "</span>
                  <span id="example1">
                    {this.getexampleForLanguage(this.props.appState.language,"source")}
                  </span> 
                  <span>"</span>, 
                  <br></br>
                  type <span>      "</span>
                  <span id="example2">
                    {this.getexampleForLanguage(this.props.appState.language,"eng")}
                  </span> 
                  <span>"</span>
                </div>
              ) : null}
              
	        </div>

        </div>

        <div className="flex-container">
          <button id="save" className="btn btn-circle btn-xl mr-4 mb-4" disabled={true}>
            <FontAwesomeIcon icon={faSave} size="4x" />
            Save & Continue
          </button>
          <button
            className="btn btn-dark"
            onClick={() => this.setState({ showDoneModal: true })}
          >
            Quit
          </button>
        </div>
        
        {/* <br></br>
        <div className="flex-container">
          Add 2 buttons here and uncomment to get 2 buttons in one line and 2 in the next
        </div> */}
        {/*<div className="flex-container mt-5">
          
        </div>*/}
        
        <div className="flex-container mt-2" style={{ height: "200px" }}>
          <div className="card" style={{ width: "25rem" }}>
            <div className="card-body">
              <h5 id="contribution" className="card-title flex-container">
                Your total contribution:
              </h5>
              <div className="flex-container">
                <b>
                  {this.state.languageDurationRecorded}s
                </b>
                ({this.capitalizeFirstLetter(this.props.appState.language)}){","}
                &nbsp;
                <b>
                  {this.state.totalDurationRecorded}s
                </b>
                (Total){","}
                &nbsp;
                No. of Tasks: 
                <b>
                  {this.state.sentenceId.toString()}
                </b>
              </div>
            </div>
          </div>
        </div>
        <div className="text-left ml-5">
          <b>Instructions:</b>
          <ul>
            <li>Please do the recordings in a quiet place or when the surrounding environment is quiet.</li>
            <li>Start recording by clicking on the start button.</li>
            <li>
              Speak as instructed in your prompt and click on the stop button to stop
              recording.
            </li>
            <li>
              The recording can be reviewed by clicking on the play button.
            </li>
            <li>
              For image description tasks, carefully type the exact sentence(s) you spoke in the corresponding field.
            </li>
            <li>
              You can submit the recording and text (when applicable) by clicking on the save & continue button.
            </li>
            <li>
              On successful submission, a new prompt will be displayed. If you
              wish to stop for today, you can click on the quit button.
            </li>
          </ul>
        </div>
      </div>
    );
  }

  getexampleForLanguage = (lang, flag) => {
    if (["bodo", "dogri", "konkani", "maithili", "manipuri", "odia", "sanskrit", "santali", "sindhi"].includes(lang)){
      lang = "hindi";
    } 

    if (flag === "source") {
      console.log(flag);
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("example1").innerHTML = doc.data().imag;
      });
    } 
    else {
      console.log(flag);
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("example2").innerHTML = doc.data().trans_example;
      });
    }
  }

  getPromptForLanguage = (lang, sentenceId) => {
  	if (["bodo", "dogri", "konkani", "santali", "sindhi"].includes(lang)){
  		lang = "hindi";
  	} 

    //console.log(sentenceId.toString().slice(-2))
    if (sentenceId === 0 || sentenceId.toString().slice(-2) === '00') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().spon0;
      });
     // prompt="spon0"
    } else if (sentenceId === 1 || sentenceId.toString().slice(-2) === '01') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().spon1;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 2 || sentenceId.toString().slice(-2) === '02') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_a;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 3 || sentenceId.toString().slice(-2) === '03') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_i;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 4 || sentenceId.toString().slice(-2) === '04') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_o;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 5 || sentenceId.toString().slice(-2) === '05') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_u;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 6 || sentenceId.toString().slice(-2) === '06') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_ae;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 7 || sentenceId.toString().slice(-2) === '07') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_s;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 8 || sentenceId.toString().slice(-2) === '08') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_sh;
      });
      //prompt="spon1"
    } 
    else if (sentenceId === 9 || sentenceId.toString().slice(-2) === '09') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().phon_f;
      });
      //prompt="spon1"
    } 
    //else if (sentenceId > 1 && sentenceId < 10 ) {
    //  firebase
     // .firestore()
     // .collection("Sentences")
     // .doc(lang)
     // .collection("prompt")
     // .doc("prompt")
     // .get()
     // .then((doc) => {
     //   document.getElementById("prompt").innerHTML = doc.data().phon;
     // });
      //prompt="spon1"
    //}

    //else if (sentenceId > 9 && sentenceId < 15 ) {
    //  firebase
    //  .firestore()
    //  .collection("Sentences")
    //  .doc(lang)
    //  .collection("prompt")
    //  .doc("prompt")
    //  .get()
    //  .then((doc) => {
    //    document.getElementById("prompt").innerHTML = doc.data().didk;
    //  });
      //prompt="spon1"
    //}
    else if (sentenceId.toString().slice(-2) === '10') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().didk_pa;
      });
      //prompt="spon1"
    }
    else if (sentenceId.toString().slice(-2) === '11') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().didk_ta;
      });
      //prompt="spon1"
    }
    else if (sentenceId.toString().slice(-2) === '12') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().didk_ka;
      });
      //prompt="spon1"
    }
    else if (sentenceId.toString().slice(-2) === '13') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().didk_ptk;
      });
      //prompt="spon1"
    }
    else if (sentenceId.toString().slice(-2) === '14') {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().didk_bdg;
      });
      //prompt="spon1"
    }   
    else {
      firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().imag;
      });
     // prompt="prompt"
    }

   //////// firebase
    //  .firestore()
    //  .collection("Sentences")
   //   .doc(lang)
   //   .collection("prompt")
   //   .doc("prompt")
   //   .get()
   //   .then((doc) => {
   //     document.getElementById("prompt").innerHTML = doc.data().prompt;
   //   });
  };

  getFolderLoc = (lang, sentenceId) => {

    //if (sentenceId === 0 || sentenceId ===1){
    //  return "stimuli/spon/"
   // }
    //else if (sentenceId >1 & sentenceId <10){
     // return "stimuli/phon/"
    //}
    //else if (sentenceId >9 & sentenceId <15){
    //  return "stimuli/didk/"
    //}
    //else{
    //  return "stimuli/imag/"
    //}
   // return "Stimuli/" + lang;
    return "stimuli/";
  };

  getImageLoc = (lang, sentenceId) => {
    //console.log("Stimuli/" + lang + "/pic_" + sentenceId + ".jpg");
    //return this.getFolderLoc(lang) + "/pic_" + sentenceId + ".jpg";
	if (Number(sentenceId.toString().slice(-2)) > 0 && Number(sentenceId.toString().slice(-2)) < 10) {
	    console.log("stimuli/pic_" + sentenceId.toString().slice(-1) + ".jpg")
	    return this.getFolderLoc(lang, sentenceId) + "pic_" + sentenceId.toString().slice(-1) + ".jpg";
	}
	else if (Number(sentenceId.toString().slice(-2)) > 9 && Number(sentenceId.toString().slice(-2)) < 16) {
	    console.log("stimuli/pic_" + sentenceId.toString().slice(-2) + ".jpg")
	    return this.getFolderLoc(lang, sentenceId) + "pic_" + sentenceId.toString().slice(-2) + ".jpg";
	}
	else{
	    console.log("stimuli/pic_" + sentenceId + ".jpg")
	    return this.getFolderLoc(lang, sentenceId) + "pic_" + sentenceId + ".jpg";
	}      
  };

  displaySentence = (lang, sentenceId) => {
    console.log("Image uploading");
    firebase
      .storage()
      .ref(this.getImageLoc(lang, sentenceId))
      .getDownloadURL()
      .then((url) => {
        console.log(url);
        document.getElementById("sentence").src = url;
      });
  };

  getRandomSentenceFromFirestore = (lang, sentenceId) => {
    console.log(lang, sentenceId);
    if (this.totalSentences !== null) {
      this.displaySentence(lang, sentenceId + 1);
    } else {
      firebase
        .storage()
        .ref(this.getFolderLoc(lang,sentenceId))
        .list()
        .then((images) => {
          this.totalSentences = images.items.length;
          //console.log("Total number of images", this.totalSentences);
          this.totalSentences = (this.totalSentences/100 >> 0)*15 + this.totalSentences; // First 15 images will repeat after every hundred
          console.log("Total number of images", this.totalSentences);
          this.displaySentence(lang, sentenceId + 1);
        });
    }
    // if (this.language !== lang) {
    //   this.language = lang;
    //   console.log("Snapshot is null");
    //   console.log(sentenceId);

    //   sentenceId = Math.floor(Math.random() * 50);
    //   console.log("Random sentence Id", sentenceId);
    //   this.setState({ sentenceId: sentenceId });
    //   this.displaySentence(lang, sentenceId);
    // } else {
    //   this.displaySentence(lang, sentenceId);
    // }
  };

  /*
  getSentenceFromFirestore = (lang, id) => {
    firebase
      .firestore()
      .collection("Sentences")
      .where("language", "==", lang)
      .where("id", "==", id)
      .get()
      .then((snapshot) =>
        snapshot.docs.forEach((doc) =>
          this.displaySentence(doc.data().sentence)
        )
      );
  };*/
}

export default RecordingPage;
